module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAARFJREFUOE/F1L9KxEAQBvD5kBSCSDpfII0QAxls0ohgKz6AlXaW4pv4BiKK/Vkrh2A7gZgy2NsFywT59ISDKJvLRgJuPfx2/u1CJj6Y2JP/B+M43irL8q2vslEZquo2gEeSd2Z24UK9wQ72BOCA5LUL9QI72MzMzlT1GMANySMzu+9mOgg6sB0ADyRvzez8d9krwbHYAu8F/4L1glmWrTdN80py2bOVZQ72ME3TXQDPADZILlalt2dePVTVUwCXJOdfe7dH8so1AO89VNVDETkRkReSeZ7nM983P7g2vtAy7geYJEkcBMFcRNY8oY+2bfeLoiidYBRFm2EYqif2HVbXtVVV9e4Ex0CT/DY+F04+lE+wZp0V0bPUvwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_edit.png
// module id = 740
// module chunks = 1